import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { TokenAuthService } from './token-auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FixedBurdenPlanService {

constructor(public tokenAuthService: TokenAuthService,
    private httpClient: HttpClient,
  ) { }

  readonly fixedBurdenPlanUrl = `${environment.base_URL}${environment.fixed_burden_plan_URL}`;
 

  getFixedBurdenPlans(): Observable<any> {
        const url = `${this.fixedBurdenPlanUrl}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  submitFixedBurdenPlanForApproval(fixedBurdenPlanDto: any): Observable<any> {
    const url = `${this.fixedBurdenPlanUrl}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any[]>(url, fixedBurdenPlanDto, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  getFixedBurdenPlanPendingApprovals(): Observable<any> {
    const url = `${this.fixedBurdenPlanUrl}/pending`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  viewFixedBurdenPlanById(planId: any): Observable<any> {
    const url = `${this.fixedBurdenPlanUrl}/pending/${planId}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

   approveFixedBurdenPlan(planId: any): Observable<any> {
    const url = `${this.fixedBurdenPlanUrl}/approve/${planId}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any>(url, {}, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  rejectFixedBurdenPlan(planId: any): Observable<any> {
    const url = `${this.fixedBurdenPlanUrl}/reject/${planId}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any>(url, {}, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  updateFixedBurdenPlan(planId: any, fixedBurdenPlanDto: any): Observable<any> {
    const url = `${this.fixedBurdenPlanUrl}/${planId}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.put<any>(url, fixedBurdenPlanDto, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  deleteFixedBurdenPlan(planId: any): Observable<any> {
    const url = `${this.fixedBurdenPlanUrl}/${planId}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.delete<any>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

    getFixedBurdenPlan(workerType: any): Observable<any> {
    const url = `${this.fixedBurdenPlanUrl}/workerType/${workerType}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

    
}
